import { createEntityAdapter } from '@ngrx/entity';
import { ValeurFichierEntityState } from '@get/api-interfaces';
import { CustomEntityState } from '@get/store/configs/states';

export type IState = CustomEntityState<ValeurFichierEntityState>;

export const adapter = createEntityAdapter<ValeurFichierEntityState>({
  selectId: o => o.idValeurFichier
});
export const initialState: IState = adapter.getInitialState({
  isLoaded: false,
  isLoading: false,
  actives: []
});

export const valeurFichierFeatureKey = 'valeurFichier';
